import { TypeUnit } from '../models';

export const typeUnit: TypeUnit[] = [
  { value: 'cmkg', label: 'cmkg', scale: 5000, scaleArea: 1000000, size: 'cm', weight: 'kg', area: 'm3' },
  { value: 'inlb', label: 'inlb', scale: 139, scaleArea: 1728, size: 'in', weight: 'lb', area: 'ft3' },
];
